import { createSlice } from "@reduxjs/toolkit";
import { getReportProject } from "./thunk";
import { act } from "react";

export const initialState = {
  reportData: [],  
  error: {},
  isReportSuccess: false,
  isReportCreated: false,
};


const reportSlice = createSlice({
  name: "ReportSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getReportProject.fulfilled, (state, action) => {
      state.reportData = action.payload;  
      state.isReportSuccess = true;
      state.error = null;  
    });

    builder.addCase(getReportProject.rejected, (state, action) => {
      state.error = action.payload || "Failed to fetch project report";  
      state.isReportSuccess = false;                                       
    });
  },
});

export default reportSlice.reducer;
